import { render } from "./OrderTotals.vue?vue&type=template&id=70c08044&scoped=true&ts=true"
import script from "./OrderTotals.vue?vue&type=script&lang=ts"
export * from "./OrderTotals.vue?vue&type=script&lang=ts"

import "./OrderTotals.vue?vue&type=style&index=0&id=70c08044&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.27_typescript@5.9.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c08044"]])

export default __exports__